import api from '../api.js';
import db from '../../versa/db.js';
import crud from '../../versa/crud.js';
import { notify } from '../../versa/msgbox.js';
import view from '../views/units.js';
import form from '../forms/units.js';
import * as types from '../types.js';

const units = function()
{

	let units_crud = crud.create({
		async loadBaseData()
		{
			api.call(api.list_companies, this.queryAll()).then((data) => db.set('companies', data).catch(error => notify(error)));
		},
		async queryData(query)
		{
			return await api.call(api.list_units, query);
		},
		async loadRecord(id)
		{
			return await api.call(api.select_unit, ...JSON.parse(id));
		},
		async saveRecord(data, old_data)
		{
			let _record = {
				name: data.name,
				unit: data.unit,
				factor: Number(data.factor),
				operation: data.operation
			};
			if (old_data)
				return await api.call(api.update_unit, data.company_id, data.id, _record);
			else
				return await api.call(api.insert_unit, data.company_id, _record);
		},
	});
	
	// Index = position in the backend's SELECT
	let fieldspecs = [
		{ index: 1, field: 'company_id', label: 'Empresa', types: [types.datalist()], placeholder: '', title: 'Empresa', store: 'companies', labels: ['nick'] },
		{ index: 2, field: 'id', label: 'Unidade', types: [types.number(0, 2)], placeholder: '0', title: 'Identificador da unidade' },
		{ index: 3, field: 'name', label: 'Nome', types: [types.name()], placeholder: '', title: 'Nome da unidade' },
		{ index: 4, field: 'unit', label: 'Unidade', types: [types.caps()], placeholder: '', title: 'Sigla da unidade' },
		{ index: 5, field: 'factor', label: 'Fator', types: [types.number(3)], placeholder: '0,000', title: 'Fator de multiplicação ou divisão da unidade' },
		{ index: 6, field: 'operation', label: 'Operação', types: [types.opt_unit_operation(), types.datalist()], placeholder: '', title: 'Operação da unidade (multiplicação ou divisão)' },
	];

	units_crud.run(
		'units',
		'Unidades',
		document.getElementById('workarea'),
		view,
		form,
		fieldspecs
	);

};

export default units;

